<script setup lang="ts">
import type { RadioGroupProps } from "./radio.types";
import { useRadioGroup } from "./useRadioGroup";
import { VisuallyHiddenInput } from "components/VisuallyHidden";

defineOptions({ name: "ERadioGroup" });

const props = withDefaults(defineProps<RadioGroupProps>(), {
  color: "neutral",
  variant: "subtle",
  size: "md",
  disabled: false,
  orientation: "vertical",
});

const { state, classes, ariaDisabled } = useRadioGroup({ props });
</script>

<template>
  <div part="base" :class="classes" role="radiogroup" :aria-disabled="ariaDisabled">
    <slot />

    <visually-hidden-input
      :name="state.name?.value"
      :value="state.modelValue?.value"
      :required="state.required?.value"
      :disabled="state.disabled?.value"
      type="radio"
    />
  </div>
</template>
